import useDetectScrollState from "./useDetectScrollState";

export default useDetectScrollState;
